import Form from "./components/Form/Form";
import Result from "./components/Result/Result";
import Title from "./components/Title/Title";

function App() {
  return (
    <div className="container">
      <Title />
      <Form />
      <Result />
    </div>
  );
}

export default App;
